import {Injectable} from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import {Market} from '../models/dealers/market.enum';
import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from '../../environments/environment';
import {JwtHelperService} from "@auth0/angular-jwt";
import {I18nProvider, i18nProviderFactory} from "../services/i18n.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly LANGUAGE_ENGLISH = 'en';

  constructor(private i18nProvider: I18nProvider) {
  }

  public isAuthenticated(): boolean {
    const helper = new JwtHelperService();
    const token = sessionStorage.getItem('DWP_TOKEN');
    if (token === null) {
      return false;
    }
    this.initializeI18nProvider();
    return !helper.isTokenExpired(token);
  }
  private initializeI18nProvider(): void {
    // Call the i18nProviderFactory function
    i18nProviderFactory(this.i18nProvider);
  }
  public isAdmin(): boolean {
    return sessionStorage.getItem('role') === 'DWCP_ADMIN' ||
      sessionStorage.getItem('role') === 'DWP_ADMIN';
  }

  public isUser(): boolean {
    return sessionStorage.getItem('role') === 'DWCP_USER' ||
      sessionStorage.getItem('role') === 'DWP_USER';
  }

  public isReadOnlyUser(): boolean {
    return sessionStorage.getItem('role') === 'DWCP_READONLY' ||
      sessionStorage.getItem('role') === 'DWP_READONLY';
  }

  public market(): Market {
    return sessionStorage.getItem('market') as Market;
  }

  getHeaders(): HttpHeaders {
    if (sessionStorage.getItem('DWP_TOKEN')) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: sessionStorage.getItem('DWP_TOKEN')
      });
    } else {
      return new HttpHeaders();
    }
  }

  public getUser(): string {
    return sessionStorage.getItem('user');
  }

  public getSelectedLanguage(): string {
    return localStorage.getItem('selectedLanguage');
  }

  public isSelectedLanguageEnglish(): boolean {
    return this.getSelectedLanguage() ? this.LANGUAGE_ENGLISH === this.getSelectedLanguage().toLowerCase() : false;
  }

  public authCodeFlowConfig(): AuthConfig {
    return {
      // Url of the Identity Provider
      issuer: environment.oauth2.issuer,
      // URL of the SPA to redirect the user to after login
      redirectUri: environment.oauth2.redirectUri,
      postLogoutRedirectUri: environment.oauth2.postLogoutRedirectUri,
      // The SPA's id. The SPA is registerd with this id at the auth-server
      // clientId: 'server.code',
      clientId: environment.oauth2.clientId,
      // Just needed if your auth server demands a secret. In general, this
      // is a sign that the auth server is not configured with SPAs in mind
      // and it might not enforce further best practices vital for security
      // such applications.
      // dummyClientSecret: 'secret',
      responseType: 'id_token token',
      // set the scope for the permissions the client should request
      // The first four are defined by OIDC.
      // Important: Request offline_access to get a refresh token
      // The api scope is a usecase specific one
      scope: environment.oauth2.scope,
      customQueryParams: environment.oauth2.options,
      showDebugInformation: environment.oauth2.showDebugInformation,
    };
  }
}
